// extracted by mini-css-extract-plugin
module.exports = {"chromeframe":"ProjectText_chromeframe__1dKqe","main":"ProjectText_main__3eI_8"};